import YesCard from './YesCard';

export default YesCard;
